module.exports = __webpack_public_path__ + "static/media/quienes-somos.a309778c.png";